module.exports = __webpack_public_path__ + "img/film.d80da2c0.jpg";